import React, { useEffect, useCallback, useMemo } from 'react';
import { Support } from '../../hooks/Support';
import Hls from 'hls.js';

export type AirPlayProps = {
  authorization: string;
  enabled: boolean;
  hls: Hls;
  code: string;
  video: string;
  videoName: string;
  videoPoster: string;
  supported: Support;
};

declare global {
  interface HTMLElement {
    webkitShowPlaybackTargetPicker: () => Promise<void>;
  }
}

const AirPlay = ({ authorization, enabled, hls, code, video, videoName, videoPoster, supported }: AirPlayProps) => {
  const [isAirPlay, setIsAirplay] = React.useState<boolean>(false);

  const airPlayVideo = useCallback(() => {
    if (!supported.airplay || !hls.media) {
      return;
    }

    // const source = document.createElement('source');
    // source.src = video;

    const rootElement = document.querySelector(`[data-code="${code}"]`) as HTMLDivElement;
    // const videoElement = rootElement.querySelector('video') as HTMLVideoElement;
    // videoElement.appendChild(source);
    // videoElement.disableRemotePlayback = false;

    const video = rootElement.querySelector('video') as HTMLVideoElement;
    video.disableRemotePlayback = false;
    video?.webkitShowPlaybackTargetPicker();

    // hls.media.webkitShowPlaybackTargetPicker();
  }, [hls, code, video, supported.airplay]);

  const onAirplayOpen = useCallback(() => {
    setIsAirplay(true);
  }, []);

  const onAirplayClose = useCallback(() => {
    setIsAirplay(false);
  }, []);

  useEffect(() => {
    if (!hls || !hls.media) {
      return;
    }

    hls.media.addEventListener('webkitplayingremotely', onAirplayOpen);

    hls.media.addEventListener('webkitsessionclosed', onAirplayClose);

    return () => {
      if (!hls || !hls.media) {
        return;
      }

      hls.media.removeEventListener('webkitplayingremotely', onAirplayOpen);
      hls.media.removeEventListener('webkitsessionclosed', onAirplayClose);
    };
  }, [hls]);

  return useMemo(() => (
    enabled && supported.airplay ? (
      <div className={`${isAirPlay ? 'smartplayer__airplay--active' : 'smartplayer__airplay--inactive'}`} onClick={() => airPlayVideo()}>
        <button className="smartplayer__bar-button" type="button" disabled={!supported.airplay}>
          <div className="icon icon--airplay-active">
            <svg xmlns="http://www.w3.org/2000/svg" height="32" width="36" viewBox="0 0 576 512" fill="currentColor">
              <path d="M480 96H96c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32h69.5l-50.7 50.7c-4 4-7.4 8.5-10.2 13.3H96c-53 0-96-43-96-96V128C0 75 43 32 96 32H480c53 0 96 43 96 96V320c0 53-43 96-96 96h-8.6c-2.8-4.8-6.2-9.2-10.2-13.3L410.5 352H480c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32zM265.4 297.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H160c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z"/>
            </svg>
          </div>
          <div className="icon icon--airplay-inactive">
            <svg xmlns="http://www.w3.org/2000/svg" height="32" width="36" viewBox="0 0 576 512" fill="currentColor">
              <path d="M480 96H96c-17.7 0-32 14.3-32 32V320c0 17.7 14.3 32 32 32h69.5l-50.7 50.7c-4 4-7.4 8.5-10.2 13.3H96c-53 0-96-43-96-96V128C0 75 43 32 96 32H480c53 0 96 43 96 96V320c0 53-43 96-96 96h-8.6c-2.8-4.8-6.2-9.2-10.2-13.3L410.5 352H480c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32zM265.4 297.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H160c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z"/>
            </svg>
          </div>
        </button>
      </div>
    ) : null
  ), [enabled, isAirPlay, supported.airplay, airPlayVideo]);
};

export default AirPlay;
